import { deepDive } from "@/mocks/hotlist";

export default function DeepDive() {
  return (
    <section id="deepdive" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <nav aria-label="面包屑导航" className="mb-6 flex items-center gap-2 text-xs md:text-sm text-foreground-500">
            <a href="#top" className="hover:text-primary-400 transition-colors cursor-pointer">
              首页
            </a>
            <i className="ri-arrow-right-s-line" />
            <a href="#ranking" className="hover:text-primary-400 transition-colors cursor-pointer">
              热门复盘
            </a>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-700 truncate">{deepDive.title.replace("#", "")}</span>
          </nav>

          <article className="rounded-lg border border-background-200/70 bg-background-100 overflow-hidden">
            <div className="relative w-full h-[220px] md:h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20flat%20lay%20of%20scattered%20paper%20notes%20and%20glowing%20amber%20question%20mark%20shapes%20on%20dark%20charcoal%20surface%2C%20editorial%20magazine%20style%20still%20life%2C%20warm%20crimson%20accent%20lighting%2C%20moody%20soft%20shadows%2C%20high%20detail%2C%20no%20text&width=1400&height=700&seq=heiliaohome-deepdive-notes&orientation=landscape"
                alt="热门话题复盘配图：深色桌面上散落的便签与琥珀色标记"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent" />
            </div>

            <div className="p-5 md:p-8 lg:p-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
              <div className="lg:col-span-7">
                <span className="text-xs md:text-sm text-accent-400 font-medium">{deepDive.kicker}</span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                  {deepDive.title}
                </h2>
                <p className="mt-3 text-sm md:text-base text-primary-400 font-medium">
                  {deepDive.highlight}
                </p>
                <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {deepDive.intro}
                </p>

                <h3 className="mt-9 font-heading text-lg md:text-xl font-bold text-foreground-950">
                  关键节点时间线
                </h3>
                <ol className="mt-5 relative">
                  <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300/60" />
                  {deepDive.timeline.map((node) => (
                    <li key={node.time} className="relative pl-8 pb-6 last:pb-0">
                      <span className="absolute left-0 top-1.5 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50" />
                      <span className="font-heading text-sm font-bold text-primary-400 tabular-nums">
                        {node.time}
                      </span>
                      <p className="mt-1.5 text-sm md:text-base text-foreground-700 leading-relaxed">
                        {node.text}
                      </p>
                    </li>
                  ))}
                </ol>
              </div>

              <aside className="lg:col-span-5">
                <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    三个必须知道的点
                  </h3>
                  <div className="mt-5 space-y-5">
                    {deepDive.points.map((point, index) => (
                      <div key={point.title} className="flex gap-3">
                        <span className="shrink-0 w-7 h-7 rounded-md bg-primary-500/15 text-primary-400 flex items-center justify-center font-heading text-sm font-bold">
                          {index + 1}
                        </span>
                        <div>
                          <h4 className="font-medium text-sm md:text-base text-foreground-950">
                            {point.title}
                          </h4>
                          <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">
                            {point.text}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-4 rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    相关话题
                  </h3>
                  <ul className="mt-4 space-y-2">
                    {deepDive.related.map((rel) => (
                      <li key={rel}>
                        <a
                          href="#ranking"
                          className="flex items-center justify-between gap-3 px-3 py-3 rounded-md bg-background-200/50 text-sm text-foreground-800 hover:text-primary-400 transition-colors cursor-pointer"
                        >
                          <span className="truncate">{rel}</span>
                          <i className="ri-arrow-right-up-line shrink-0" />
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </aside>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}